import { Divider, DividerPosition } from 'omakase';
import { FunctionComponent } from 'react';
import { dividerThinDesktop } from './formBlockCssDefs';

const DesktopDivider: FunctionComponent<{ position?: DividerPosition }> = ({
  position,
  ...rest
}) => (
  <Divider
    data-testid="divider-testid-thin"
    css={dividerThinDesktop}
    position={position}
    variant="thin"
    {...rest}
  />
);

export default DesktopDivider;
